var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "plan-feature" } }, [
    _c("div", { staticClass: "feature" }, [
      _c("div", { staticClass: "feature-title" }, [
        _vm._v("Customer Tables Feature"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "feature-delete",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("span", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "feature-form" }, [
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.customerTablesEntegration,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "customerTablesEntegration", $$v)
                  },
                  expression: "featureForm.customerTablesEntegration",
                },
              },
              [_vm._v("Customer Table")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.customerTableLinkedFeature,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "customerTableLinkedFeature", $$v)
                  },
                  expression: "featureForm.customerTableLinkedFeature",
                },
              },
              [_vm._v("Tablo İlişkilendirme")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.customerTableAIFeature,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "customerTableAIFeature", $$v)
                  },
                  expression: "featureForm.customerTableAIFeature",
                },
              },
              [_vm._v("AI Destekli Kayıt")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.customerTableModuleFeature,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "customerTableModuleFeature", $$v)
                  },
                  expression: "featureForm.customerTableModuleFeature",
                },
              },
              [_vm._v("Tablo Modülleştirme")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.customerTableReportFeature,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "customerTableReportFeature", $$v)
                  },
                  expression: "featureForm.customerTableReportFeature",
                },
              },
              [_vm._v("Tablo Rapor Oluşturma")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "feature-label" }, [
          _vm._v("Tablo Oluşturma Limiti"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.customerTableCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "customerTableCount", $$v)
                },
                expression: "featureForm.customerTableCount",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "feature-label" }, [
          _vm._v("Tablo Başına Alan"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.customerTableFieldCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "customerTableFieldCount", $$v)
                },
                expression: "featureForm.customerTableFieldCount",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "feature-label" }, [
          _vm._v("Tablo Başına Kayıt"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.customerTableRecordCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "customerTableRecordCount", $$v)
                },
                expression: "featureForm.customerTableRecordCount",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "feature-label" }, [
          _vm._v("Tablo Başına Görüntü Oluşturma"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.customerTableViewCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "customerTableViewCount", $$v)
                },
                expression: "featureForm.customerTableViewCount",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }